import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router";
import { Row, Col } from "antd";
import ExpoMovil from "./ExpoMovil";
import ExpoWeb from "./ExpoWeb";


const Expo = (props) => {
  const { idioma } = props;

  return (
    <>
      <Row>
        <Col xs={24} md={0}>
          <ExpoMovil idioma={idioma}  />
        </Col>
        <Col xs={0} md={24}>
          <ExpoWeb idioma={idioma} />
        </Col>
      </Row>
    </>
  );
};

export default Expo;
